import { PopoverPlacement } from "@idui/react-popover";
import { FC, ReactNode } from "react";

import { SVG_MUI } from "@ryde/assets";
import { FramerTooltip } from "@ryde/controls";
import { Log } from "@ryde/shared";

interface IDurationLabelBoardingSegmentExceededProps {
  boardingSegmentDurationDisplayValue: string | number;
  maxSegmentDurationDisplayValue: string | number;
  displayContent: string;
  tooltipContent: ReactNode;
}

export const DurationLabelBoardingSegmentExceeded: FC<
  IDurationLabelBoardingSegmentExceededProps
> = ({
  boardingSegmentDurationDisplayValue,
  maxSegmentDurationDisplayValue,
  displayContent,
  tooltipContent,
}) => {
  Log.debug(
    `Boarding segment duration exceeded, boarding segment duration: ${boardingSegmentDurationDisplayValue}> max segment duration:${maxSegmentDurationDisplayValue}`,
  );

  return (
    <FramerTooltip placement={PopoverPlacement.bottom} content={tooltipContent}>
      <label
        data-e2e="ride-boarding-segment-duration"
        className="rideBoardingSegmentDurationLabel_exceeded"
      >
        <SVG_MUI.CircleExclamation className="rideTotalDurationLabel-exclamationIcon" />
        {displayContent}
      </label>
    </FramerTooltip>
  );
};
